export default {
	mounted(){}
}
